export default {
  ERROR_LOADING_ORG_SETTINGS_message:
    'An unexpected error occured while attempting to load settings for your org. Please reload the current browser window and try again.',
  ERROR_UPDATING_ORG_SETTING_message:
    'An unexpected error occured while attempting to update the specified org setting. Please try again.',
  SUCCESS_UPDATING_ORG_SETTING_message:
    'The org setting has been successfully updated.',
  title: 'Other Settings'
};
